export default __webpack_public_path__ + "static/media/btn-search.e034059e.svg";